import ownerDocument from './ownerDocument';
export default function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
// module id = IPIp
// module chunks = 0